import LeftSide from "/components/layouts/leftSide";
import InfoMenu from "../../components/pages/faq/menu";
import { wrapper } from "../../redux";
import { fetchQuestions } from "../../redux/action-creaters/content";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import Redis from "/lib/redis";
import { useSelector } from "react-redux";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import styles from "./index.module.scss";
import Button from "../../components/common/button";
import { sspWrapper } from "../../utils/errors/sspWrapper";

export default function RefundPage({ scripts, host, isBaltex, headers }) {
  const { content } = useSelector((state) => state.meta);
  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <span style={{ display: "none" }}>{headers}</span>
      <LeftSide
        isBaltex={isBaltex}
        side={<InfoMenu isBaltex={isBaltex}></InfoMenu>}
        title="Возврат товара"
      >
        <div className={"text"}>
          <div dangerouslySetInnerHTML={{ __html: content }} />
          <div className={styles.Form}>
            <h3>ЗАЯВЛЕНИЕ</h3>
            <p>
              Прошу Вас вернуть мне денежные средства, оплаченные мною по
              платежному документу <input /> (наименование вида документа) №
              <input />
              от <input />
              201
              <input />
              г. в сумме <input /> ввиду
              <input />
              (указать причины возврата).
            </p>
            <p>Банковские реквизиты: </p>{" "}
            <p>
              Банк
              <input />{" "}
            </p>
            <p>
              р/сч
              <input />
            </p>{" "}
            <p>
              к/сч <input />{" "}
            </p>{" "}
            <p>
              БИК
              <input />
            </p>
            <div>
              <Button onClick={() => {}} label={"Отправить"} />
            </div>
          </div>
        </div>
      </LeftSide>
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ req, query, resolvedUrl }) => {
    await store.dispatch(await fetchQuestions(Redis));
    store.dispatch(addBreadcrumb({ link: "/refund/", name: "Возврат товара" }));
    return pagesWrapper(
      {
        headers: JSON.stringify(req.headers),
        pageType: SITE_PAGE_TYPE.static,
      },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/refund/",
    );
  }),
);
